import React from 'react';
import moment from 'moment';
import { formatBookingDate, formatDateAndTime } from '../../../function/Helper';

interface IProps {
  tickets: any;
  bookingInfo: any;
}

const SpecificBookingDetails = (props: IProps) => {
  const { bookingInfo } = props;

  return (
    <div className="xl:h-[calc(100vh-264px)] flex flex-col gap-3 p-2 xl:p-4 overflow-y-auto">
      <div className="flex justify-between items-center">
        <div className="flex gap-8">
          <label className="text-xs md:text-sm text-white font-bold">Booking ID</label>
          <label className="text-xs md:text-sm text-white font-normal">
            {bookingInfo.bookingId}
          </label>
        </div>
      </div>

      <div className="flex gap-4">
        <label className="text-xs md:text-sm text-white font-bold">Register Date</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {/* {moment(bookingInfo.createdAt).local().format('L')} */}
          {formatDateAndTime(bookingInfo.createdAt)}
        </label>
      </div>

      <div className="flex gap-4">
        <label className="text-xs md:text-sm text-white font-bold">Booking Date</label>
        <label className="text-xs md:text-sm text-white font-normal">
          {bookingInfo.bookingType === 'booking_restaurant_table'
            ? formatBookingDate(bookingInfo.booking_date_time)
            : formatBookingDate(bookingInfo.booking_date)}
        </label>
      </div>

      <div className="flex gap-[72px]">
        <label className="text-xs md:text-sm text-white font-bold">Email</label>
        <label className="text-xs md:text-sm text-white font-normal">{bookingInfo.email}</label>
      </div>

      <div className="flex gap-[68px]">
        <label className="text-xs md:text-sm text-white font-bold">Phone</label>
        <label className="text-xs md:text-sm text-white font-normal">{bookingInfo.phone}</label>
      </div>

      {bookingInfo.bookingType === 'booking_room' ? (
        <>
          <div className="flex gap-[77px]">
            <label className="text-xs md:text-sm text-white font-bold">Price</label>
            <label className="text-xs md:text-sm text-white font-normal">{bookingInfo.price}</label>
          </div>

          <div className="flex gap-[65px]">
            <label className="text-xs md:text-sm text-white font-bold">Rooms</label>
            <label className="text-xs md:text-sm text-white font-normal">
              {bookingInfo.num_rooms}
            </label>
          </div>

          <div className="flex gap-[37px]">
            <label className="text-xs md:text-sm text-white font-bold">Room Type</label>
            <label className="text-xs md:text-sm text-white font-normal">
              {bookingInfo.roomType}
            </label>
          </div>

          <div className="flex gap-[68px]">
            <label className="text-xs md:text-sm text-white font-bold">Adults</label>
            <label className="text-xs md:text-sm text-white font-normal">
              {bookingInfo.num_adults}
            </label>
          </div>

          <div className="flex gap-[50px]">
            <label className="text-xs md:text-sm text-white font-bold">Childrens</label>
            <label className="text-xs md:text-sm text-white font-normal">
              {bookingInfo.num_children}
            </label>
          </div>
        </>
      ) : (
        <div className="flex gap-[68px]">
          <label className="text-xs md:text-sm text-white font-bold">Guests</label>
          <label className="text-xs md:text-sm text-white font-normal">
            {bookingInfo.num_guests}
          </label>
        </div>
      )}
    </div>
  );
};

export default SpecificBookingDetails;
